import { render, staticRenderFns } from "./userLoadingBlue.vue?vue&type=template&id=2fdd636d&scoped=true"
import script from "./userLoadingBlue.vue?vue&type=script&lang=js"
export * from "./userLoadingBlue.vue?vue&type=script&lang=js"
import style1 from "./userLoadingBlue.vue?vue&type=style&index=1&id=2fdd636d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdd636d",
  null
  
)

export default component.exports